import styled from '@emotion/styled';

interface KakaoChannelAddButtonProps {
    /** 강조 문구(치과용 안내 등). 없으면 기본 문구. */
    label?: string;
    /** 버튼 아래 보조 안내 문구 */
    subNote?: string;
    fullWidth?: boolean;
}

// 채널 공개 ID (반드시 '_' 접두어 포함). 예: _BAjPX
const CHANNEL_PUBLIC_ID = import.meta.env.VITE_KAKAO_CHANNEL_PUBLIC_ID || '_BAjPX';
// 채널 홈 — 네이티브 "채널 추가" 버튼 제공. app_key/도메인/세션 조건 없이 동작.
const CHANNEL_HOME_URL = `https://pf.kakao.com/${CHANNEL_PUBLIC_ID}`;

const Wrapper = styled.div`
    width: 100%;
`;

const AddButton = styled.button`
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    background: #FEE500;
    color: #191600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;

    &:hover { background: #f5dc00; }
    svg { width: 20px; height: 20px; flex-shrink: 0; display: block; }
`;

const SubNote = styled.p`
    font-size: 13px;
    color: #6b7280;
    text-align: center;
    margin: 10px 0 0;
    line-height: 1.5;
`;

const KakaoChannelAddButton = ({ label, subNote, fullWidth = true }: KakaoChannelAddButtonProps) => {
    const handleAddChannel = () => {
        // 채널 홈으로 이동 — 네이티브 "채널 추가" 버튼 제공.
        // (SDK addChannel 의 /friend 방식은 app_key/도메인/세션 조건이 까다로워 홈 방식이 가장 안정적)
        window.open(CHANNEL_HOME_URL, '_blank', 'noopener');
    };

    return (
        <Wrapper style={{ width: fullWidth ? '100%' : 'auto' }}>
            <AddButton type="button" onClick={handleAddChannel}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 4C7.03 4 3 7.13 3 11c0 2.5 1.69 4.7 4.23 5.95-.18.64-.67 2.37-.77 2.74-.12.46.17.45.36.33.15-.1 2.36-1.6 3.32-2.25.6.09 1.22.13 1.86.13 4.97 0 9-3.13 9-7C21 7.13 16.97 4 12 4z"/>
                </svg>
                {label || '카카오 채널 추가하고 소식 받기'}
            </AddButton>
            {subNote && <SubNote>{subNote}</SubNote>}
        </Wrapper>
    );
};

export default KakaoChannelAddButton;
